module.exports = __webpack_public_path__ + "static/media/logo-top-dark.3d5c1c1d.svg";